import { jsx as _jsx, jsxs as _jsxs } from "@emotion/react/jsx-runtime";
/** @jsxImportSource @emotion/react */
import { css } from '@emotion/react';
import { FaCheck, FaTimes } from 'react-icons/fa';
import { Button } from '../button/Button';
const styles = {
    toolbar: css({
        display: 'flex',
        flexDirection: 'row-reverse',
        fontSize: 16,
        padding: 3,
        '& > button': {
            padding: 0,
            paddingLeft: 9,
            minWidth: 'auto',
        },
    }),
};
export function PanelPreferencesToolbar(props) {
    const { onClose, onSave } = props;
    return (_jsxs("div", { css: styles.toolbar, children: [_jsx(Button, { onClick: onClose, color: { basic: '#ca0000', hover: '#ca0000' }, backgroundColor: { basic: 'white', hover: 'white' }, children: _jsx(FaTimes, {}) }), _jsx(Button, { onClick: onSave, color: { basic: 'green', hover: 'green' }, backgroundColor: { basic: 'white', hover: 'white' }, children: _jsx(FaCheck, {}) })] }));
}
//# sourceMappingURL=PanelPreferencesToolbar.js.map